import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicLicense } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getLicenses = async (): Promise<PublicLicense[]> => {
  const response = await axiosClient.get(`/licensing`);
  return response.data;
};

export function useLicenses(
  queryOptions?: Partial<UseQueryOptions<PublicLicense[], HttpError>>,
) {
  return useQuery({
    queryKey: ["licenses"],
    queryFn: getLicenses,
    ...queryOptions,
  });
}
